import React from "react";
import styled from "styled-components";
function ContentTitle({stackingPool}) {
  return (
    <>
      <TextContainer>
        <CardText>Pool Rate: {stackingPool?.APR?.toString() / 100}%</CardText>
      </TextContainer>
      <ContainerSpaceBetween>
        <TextContainer>
          <CardText>Pool Status:</CardText>
          {stackingPool.isOpen ? (
            <CardText>Active</CardText>
          ) : (
            <CardText>Not Active</CardText>
          )}
        </TextContainer>
      </ContainerSpaceBetween>
    </>
  );
}
const TextContainer = styled.div`
  display: flex;
  align-items: center;
  margin: 5px auto;
  display: flex;
  gap: 0.5rem;
`;

const CardText = styled.span`
  color: #fdfdfd;
  font-size: 1rem;
  margin: 0px auto;
`;
const ContainerSpaceBetween = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export default ContentTitle;
